<template lang="pug">
  y-dialog(fill-height fluid v-model="showModal" scrollable transition="fade-transition" persistent max-width="600px")
    v-card
      v-card-title.pa-4
        div.h6.basic800--text {{ affiliate.banks ? 'Edit' : 'Add' }} bank details
      v-divider.basic300
      v-card-text.pa-0
        v-form(ref="form")
          v-card.pa-4
            div.label.basic600--text.text-uppercase Bank account type
            v-select.mt-2(v-model='bank.account_type' placeholder="Select bank account type" dense outlined height="40" background-color="basic200" :items="accountTypes" item-text="text" item-value="value" :rules="rules.not_empty" hide-details="auto")
              template(v-slot:append)
                eva-icon(name="chevron-down-outline" width="24" height="24" :fill="$vuetify.theme.themes[$theme].basic700")

            div.mt-4.label.basic600--text.text-uppercase bank
            v-select.mt-2(v-model='bank.bank' placeholder="Select bank" dense outlined height="40" background-color="basic200" :items="banks" item-text="name" item-value="code" :rules="rules.not_empty" hide-details="auto")
              template(v-slot:append)
                eva-icon(name="chevron-down-outline" width="24" height="24" :fill="$vuetify.theme.themes[$theme].basic700")

            div.mt-4.label.basic600--text.text-uppercase bank account number
            v-text-field.mt-2(v-model='bank.bank_account' placeholder="Enter account number" dense outlined height="40" background-color="basic200" :rules="rules.not_empty" hide-details="auto")

            div.mt-4.label.basic600--text.text-uppercase account name
            v-text-field.mt-2(v-model='bank.account_name' placeholder="Enter account holder name" dense outlined height="40" background-color="basic200" :rules="rules.not_empty" hide-details="auto")

            template(v-if="bank.account_type === 'personal'")
              div.mt-4.label.basic600--text.text-uppercase Identity Card Number
              v-text-field.mt-2(v-model='bank.ic' placeholder="Enter your Malaysian IC number" dense outlined height="40" background-color="basic200" :rules="rules.ic_valid" hide-details="auto")

            template(v-if="bank.account_type === 'business'")
              div.mt-4.label.basic600--text.text-uppercase Company registration number
              v-text-field.mt-2(v-model='bank.ssm' placeholder="e.g: 00123456X" dense outlined height="40" background-color="basic200" :rules="rules.not_empty" hide-details="auto")

      v-card-actions.pa-2.pb-4
        v-spacer
        v-btn(text @click='showModal = false' depressed height=32 )
          .button-Aa-small.primary400--text| Cancel
        v-btn.mr-2(color='textColorAccent' depressed height=32 @click="clickSave" :loading="isLoading")
          .button-AA-small.basic100--text| Save

</template>

<script>
import { mapActions } from 'vuex'
export default {
  name: 'AddBankDialog',
  props: ['open', 'propAffiliate'],
  data: () => ({
    bank: {},
    isLoading: false,
    accountTypes: [
      { value: 'personal', text: 'Personal' },
      { value: 'business', text: 'Business' }
    ],
    banks: [
      { code: 'PHBMMYKL', name: 'Affin Bank' },
      { code: 'BPMBMYKL', name: 'Agrobank' },
      { code: 'MFBBMYKL', name: 'Alliance Bank' },
      { code: 'RJHIMYKL', name: 'Al Rajhi Banking' },
      { code: 'ARBKMYKL', name: 'AmBank' },
      { code: 'BIMBMYKL', name: 'Bank Islam' },
      { code: 'BKRMMYKL', name: 'Bank Rakyat' },
      { code: 'BMMBMYKL', name: 'Bank Muamalat' },
      { code: 'BSNAMYK1', name: 'Bank Simpanan Nasional' },
      { code: 'CIBBMYKL', name: 'CIMB' },
      { code: 'CITIMYKL', name: 'Citibank' },
      { code: 'HLBBMYKL', name: 'Hong Leong Bank' },
      { code: 'HBMBMYKL', name: 'HSBC Bank' },
      { code: 'KFHOMYKL', name: 'Kuwait Finance House' },
      { code: 'AFBQMYKL', name: 'MBSB Bank' },
      { code: 'MBBEMYKL', name: 'Maybank' },
      { code: 'OCBCMYKL', name: 'OCBC Bank' },
      { code: 'PBBEMYKL', name: 'Public Bank' },
      { code: 'RHBBMYKL', name: 'RHB Bank' },
      { code: 'SCBLMYKX', name: 'Standard Chartered Bank' },
      { code: 'UOVBMYKL', name: 'United Overseas Bank' }
    ],
    rules: {
      not_empty: [val => (val || '').length > 0 || 'This field is required'],
      ic_valid: [
        val => (val || '').length > 0 || 'This field is required',
        val =>  /^[a-zA-Z0-9]*?$/.test(val) || 'IC contains invalid characters'
      ],
    },
  }),
  computed: {
    affiliate: {
      get() {
        return this.propAffiliate
      },
      set(newValue) {
        this.$emit('update:propAffiliate', newValue)
      }
    },
    showModal: {
      get() {
        return this.open
      },
      set(newValue) {
        this.$emit('update:open', newValue)
      }
    }
  },
  watch: {
  },
  mounted () {
    if (this.affiliate) {
      this.bank = {
        bank: this.affiliate.bank || null,
        bank_account: this.affiliate.bank_account || null,
        account_name: this.affiliate.account_name || null,
        account_type: this.affiliate.account_type || 'personal',
        ssm: this.affiliate.ssm || null,
        ic: this.affiliate.ic || null,
      }
    }
  },
  methods: {
    ...mapActions([
      'showMessage'
    ]),
    clickSave() {
      if (!this.$refs.form.validate()) {
        return
      }
      if (this.bank.account_type === 'personal') {
        this.bank.ssm = null
      } else if (this.bank.account_type === 'business') {
        this.bank.ic = null
      }
      this.isLoading = true
      this.axios.patch(`/partners/${this.affiliate.id}/`, this.bank)
        .then(resp => {
          this.showModal = false
          this.affiliate = resp.data
        })
        .catch(() => {
          this.showMessage(['error', this.$t('error_message.unable_to_complete_request')])
        })
        .finally(() => {
          this.isLoading = false
        })
    }
  }
}
</script>

<style scoped>
.v-text-field--outlined >>> fieldset {
  border-color: var(--v-primary200);
}
.error--text >>> fieldset {
  border-color: var(--v-danger);
}
</style>